// MemberOfferAcceptor state — ALL of the card's state, auth and offer-accept alike.
// All transient: the only card state living outside this machine is the localStorage
// submissions store (which is the persistence for the accept outcome; endpointStatus is
// re-derived from it at construction).
//
// phase names the ONE visible form panel: accept (the claim form — the default) |
// account (email entry to sign in) | verify (emailed-code entry) | password
// (password entry) | forgot (password-reset email entry). A "sending"/"error" busy
// overlay is authBusy + authStatus, not a structural phase. `loggedIn` is an overlay
// flag on the accept phase (footer swaps to the identity row), not a phase.
export default {
  // Auth
  loggedIn: false,
  person: null,          // { id, displayName, name, email } | null (name null = not-yet-named account)
  phase: "accept",       // accept | account | verify | password | forgot
  authEmail: null,
  authBusy: false,
  authStatus: null,      // { code, tone, text } | null
  // No resend cooldown here: the AuthClient owns that clock (host.canResend() /
  // host.resendSecondsRemaining()). A machine copy would be a stale mirror — the
  // countdown recomputes from Date.now() every second.

  // Offer accept. Its own status channel, separate from authStatus — the accept flow's
  // outcome is not an auth outcome — but the same KIND of state, mutated the same way.
  // (Values: EndpointStatuses in member_offer_acceptor.js — idle | loading | error |
  // success | failure. Not imported: the host imports this machine.)
  endpointStatus: "idle",
  acceptMessage: null,   // the endpoint's response message, painted into the accept hint
};
